import { render, staticRenderFns } from "./DestinationVideoFromPcp.vue?vue&type=template&id=bb27ed72&scoped=true"
import script from "./DestinationVideoFromPcp.vue?vue&type=script&lang=js"
export * from "./DestinationVideoFromPcp.vue?vue&type=script&lang=js"
import style0 from "./DestinationVideoFromPcp.vue?vue&type=style&index=0&id=bb27ed72&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb27ed72",
  null
  
)

export default component.exports